import React from "react";
import styled from "styled-components";

import useViewStore from "../../store/useViewStore";

const Container = ({ children }) => {
  const { isMobileView } = useViewStore();

  return (
    <CContainer $isMobileView={isMobileView}>
      {children}
    </CContainer>
  );
};

const CContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 80px);
  background-color: var(--aia-bx-white);
  margin-top: -50px;
  ${(props) => props.$isMobileView ? `padding: 48px 16px;` : `padding: 48px 72px;`}
  overflow: auto;
`;

export default Container;